import { forwardRef, useContext } from "react"
import { AddressContext } from "../contexts/AddressContext";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { ParameterContext } from "../contexts/ParameterContext";
import { AuthContext } from "../contexts/AuthContext";
import { AutomaticSetAddresses } from "./AutomaticSetAddresses";
import { DropdownSetAddresses } from "./DropdownSetAddresses";
import { TextSetAddresses } from "./TextSetAddresses";

const Wishes = forwardRef(({ formData, wishChangeHandler, addWish, removeWish, isEdit, cleanSiblingInputFields, onBlurWishHandler, isMunicipality, setAutoSedGroup }, ref) => {
    const {  addressResidence } = useContext(AddressContext);
    const { parameters } = useContext(ParameterContext);
    const { user } = useContext(AuthContext);

    let loading = false;

    //Check the context is loaded and if its not set default value until load ParmeterContext
    if (parameters.nomParameters === null || parameters.nomParameters === undefined) {
        loading = true;
        return
    } else if (!isEdit) {
        loading = false;
    }
    const mainRegForm = parameters.nomParameters.find(x => x.param_name == 'MAIN_REGISTER_FORM');
    const directorRegForm = parameters.nomParameters.find(x => x.param_name == 'DIRECTOR_REGISTER_FORM');

    //const autoTimeLived = parameters.nomParameters.find(x => x.param_name == 'AUTOMATIC_TIME_LIVED');

    const RenderWishes = () => {
        if (user.role == 'Director') {
            if (directorRegForm.value == 0) {
                return <AutomaticSetAddresses
                    formData={formData}
                    wishChangeHandler={wishChangeHandler}
                    removeWish={removeWish}
                    isEdit={isEdit}
                    cleanSiblingInputFields={cleanSiblingInputFields}
                    onBlurWishHandler={onBlurWishHandler}
                    addWish={addWish}
                    setAutoSedGroup={setAutoSedGroup}
                    ref={ref}
                />
            } else if (directorRegForm.value == 1) {
                return <DropdownSetAddresses
                    formData={formData}
                    wishChangeHandler={wishChangeHandler}
                    removeWish={removeWish}
                    isEdit={isEdit}
                    cleanSiblingInputFields={cleanSiblingInputFields}
                    onBlurWishHandler={onBlurWishHandler}
                    addWish={addWish}
                    ref={ref}
                />
            } else if (directorRegForm.value == 2) {
                return <TextSetAddresses
                    formData={formData}
                    wishChangeHandler={wishChangeHandler}
                    removeWish={removeWish}
                    isEdit={isEdit}
                    cleanSiblingInputFields={cleanSiblingInputFields}
                    onBlurWishHandler={onBlurWishHandler}
                    setAutoSedGroup={setAutoSedGroup}
                    addWish={addWish}
                    ref={ref}
                />
            }
        }

        if (mainRegForm.value == 0 && addressResidence.length && !isMunicipality) {
            return <AutomaticSetAddresses
                formData={formData}
                wishChangeHandler={wishChangeHandler}
                removeWish={removeWish}
                isEdit={isEdit}
                cleanSiblingInputFields={cleanSiblingInputFields}
                onBlurWishHandler={onBlurWishHandler}
                addWish={addWish}
                setAutoSedGroup={setAutoSedGroup}
                ref={ref}
            />
        } else if (mainRegForm.value == 1 && user.role != 'Municipality') {
            return <DropdownSetAddresses
                formData={formData}
                wishChangeHandler={wishChangeHandler}
                removeWish={removeWish}
                isEdit={isEdit}
                cleanSiblingInputFields={cleanSiblingInputFields}
                onBlurWishHandler={onBlurWishHandler}
                addWish={addWish}
                ref={ref}
            />
        } else {
            return <TextSetAddresses
                formData={formData}
                wishChangeHandler={wishChangeHandler}
                removeWish={removeWish}
                isEdit={isEdit}
                cleanSiblingInputFields={cleanSiblingInputFields}
                onBlurWishHandler={onBlurWishHandler}
                setAutoSedGroup={setAutoSedGroup}
                addWish={addWish}
                ref={ref}
            />
        }
    }

    return (
        <>
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            <>
                {RenderWishes()}
            </>
        </>
    )
})

export default Wishes;
